import React from 'react';
import styled from 'styled-components';

const StyledLink = styled.a`
  display: block;
  color: ${({ theme }) => theme.colors.flowjoBlue};
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 1em;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: ${({ theme }) => theme.colors.selected};
  }
`;

interface LicenseInfoLinkProps {
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  children?: React.ReactNode;
}

const LicenseInfoLink: React.FC<LicenseInfoLinkProps> = ({ onClick, children, ...rest }) => (
  <StyledLink
    onClick={(e) => {
      e.preventDefault();
      if (onClick) {
        onClick(e);
      }
    }}
    data-testid="view-license-info-link"
    {...rest}
  >
    {children || 'View Your License Information'}
  </StyledLink>
);

export default LicenseInfoLink;
